import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Container, Row, Col, Form } from "reactstrap";

import activationOptionModalAction from "../../redux/activationOptionModal/action";
import SelectButton from "../../component/SelectButton/SelectButton";
import GradientButton from "../../component/GradientButton/GradientButton";
import GradientTextInput from "../../component/GradientTextInput/GradientTextInput";
import "./style.css";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import api from "../../config/api";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import { isNetworkRequestFailedError } from "../../config/helpers";

class Register extends Component {
  state = {
    firstName: "",
    middleName: "",
    surname: "",
    email: "",
    confirmEmail: "",
    phone: "",
    confirmPhone: "",
    office: "",
    username: "",
    password: "",
    confirmPassword: "",
    RSAPin: "",
    AgentCode: "",
    EmployerCode: "",
    StaffCode: "",
    type: "Member",
    placeholder: "RSA PIN",
    codeError: false,
    firstNameError: false,
    surnameError: false,
    emailError: false,
    confirmEmailError: false,
    phoneError: false,
    confrimPhoneError: false,
    usernameError: false,
    passwordError: false,
    confirmPasswordError: false,
    passwordErrorMessage: "",
    cEmailError: "",
    cPhoneError: "",
    cPasswordError: "",
    userRoles: [],
    isLoading: false,
  };

  componentDidMount() {
    const { history, setHistory } = this.props;
    setHistory(history);
    this.fetchAllUserRoles();
  }

  fetchAllUserRoles = async () => {
    const { setAlertMessage } = this.props;
    try {
      const userRoles = await api.getAllRoles();
      this.setState({ userRoles: userRoles.data.lstUserRoles });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? this.fetchAllUserRoles
          : null,
      });
    }
    this.setState({ isLoading: false });
  };

  buttonContainerStyle = (memberType) => {
    const { type } = this.state;
    let classes = "";
    if (type === memberType)
      classes = "register-type-select-button-container mx-1 my-1 selectedBtn";
    else classes = "register-type-select-button-container mx-1  my-1";

    return classes;
  };

  memberType(type, placeholder) {
    this.setState({ type, placeholder, codeError: false }, () => {});
  }

  validatePassword = (password) => {
    // Min char 6, requires combination of numbers and letters
    const passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[0-9])(?=.{6,})");
    return passwordRegex.test(String(password).toLowerCase());
  };

  codeField = () => {
    const { placeholder, type, codeError } = this.state;
    let key = "";
    if (type !== "nonMember")
      key = type === "Member" ? "RSAPin" : `${type}Code`;
    if (type !== "nonMember") {
      return (
        <Row>
          <Col xs={12} className="my-1">
            <GradientTextInput
              placeholder={`Enter ${placeholder}`}
              onChange={(e) =>
                this.setState({ [key]: e.target.value, codeError: false })
              }
              value={this.state[key]}
              containerClasses={codeError && "input-error"}
              errorMessage={codeError && `${placeholder} is required`}
            />
          </Col>
        </Row>
      );
    }
  };

  register = async (e) => {
    e.preventDefault();

    const {
      type,
      firstName,
      surname,
      middleName,
      email,
      confirmEmail,
      phone,
      confirmPhone,
      username,
      password,
      confirmPassword,
      userRoles,
    } = this.state;
    const { setAlertMessage } = this.props;
    let isValid = true;
    let key = "";

    if (type !== "nonMember") {
      key = type === "Member" ? "RSAPin" : `${type}Code`;
    }

    if (!firstName) {
      this.setState({ firstNameError: true });
      isValid = false;
    }

    if (!surname) {
      this.setState({ surnameError: true });
      isValid = false;
    }

    if (!email) {
      this.setState({ emailError: true });
      isValid = false;
    }

    if (!phone) {
      this.setState({ phoneError: true });
      isValid = false;
    }

    if (!confirmPhone) {
      this.setState({ confirmPhoneError: true });
      isValid = false;
    }

    if (!username) {
      this.setState({ usernameError: true });
      isValid = false;
    }

    if (!password) {
      this.setState({
        confirmPasswordError: true,
        cPasswordError: "Password is required",
      });
      isValid = false;
    }

    if (!confirmPassword) {
      this.setState({
        confirmPasswordError: true,
        cPasswordError: "Confirm Password is required",
      });
      isValid = false;
    }

    // if (password && password.length < 6)
    //   this.setState({
    //     passwordError: true,
    //     passwordErrorMessage: "Password must be 6 characters long"
    //   });

    if (confirmEmail !== "" && confirmEmail !== email) {
      this.setState({
        confirmEmailError: true,
        cEmailError: "Email Address must be same",
      });
      isValid = false;
    } else if (!confirmEmail) {
      this.setState({
        confirmEmailError: true,
        cEmailError: "Email Address is required",
      });
      isValid = false;
    }
    if (confirmPhone !== "" && confirmPhone !== phone) {
      this.setState({
        confirmPhoneError: true,
        cPhoneError: "Phone Number must be same",
      });
      isValid = false;
    } else if (!confirmPhone) {
      this.setState({
        confirmPhoneError: true,
        cPhoneError: "Phone Number is required",
      });
      isValid = false;
    }
    if (!this.validatePassword(password)) {
      this.setState({
        passwordError: true,
        passwordErrorMessage:
          "Password must atleast 6 characters long with combination of numbers and letters",
      });
      isValid = false;
    }

    if (password.length >= 6 && password !== confirmPassword) {
      this.setState({
        confirmPasswordError: true,
        cPasswordError: "Password must be same",
      });
      isValid = false;
    }

    if (!this.state[key] && this.state[key] !== undefined) {
      this.setState({ codeError: true });
    } else {
      if (!isValid) {
        return;
      }

      this.setState({ isLoading: true });
      const userType = type === "nonMember" ? "Non-Member" : type;
      const findedRole = userRoles.find(
        (role) => role.roleName.toLowerCase() === userType.toLowerCase()
      );
      let key = "";
      if (type !== "nonMember") {
        key = type === "Member" ? "RSAPin" : `${type}Code`;
      }

      const body = {
        Email: email,
        UserName: username,
        FirstName: firstName,
        MiddleName: middleName,
        Surname: surname,
        [key]: this.state[key],
        MobileNumber: phone,
        Password: password,
        ConfirmPassword: confirmPassword,
        CustomerTypeId: findedRole.id,
        RSAPin: this.state.RSAPin,
        AgentCode: this.state.AgentCode,
        EmployerCode: this.state.EmployerCode,
        StaffCode: this.state.StaffCode,
      };

      if (type === "nonMember") {
        body.RSAPin = "";
        body.AgentCode = "";
        body.EmployerCode = "";
        body.StaffCode = "";
      }

      try {
        const response = await api.register(body);
        console.log("response =>", response);
        const registeredUser = {
          email: response.data.Email,
          mobile: response.data.MobileNumber,
          RSAPin: body.RSAPin,
        };
        localStorage.setItem("registeredUser", JSON.stringify(registeredUser));
        // this.props.history.push("/useractivation");

        if (type === "Member") {
          const activationResponse = await api.getActivationStatus({
            username,
          });

          // activationResponse.data.result = {
          //   UserProfileInfo_isActive: false,
          //   PhoneNumber: "3847583475834",
          //   Email: "izaan@example.com",
          // };

          this.props.setActivationModal({
            visible: true,
            data: {
              ...activationResponse.data.result,
              UserName: username,
              MobileNumber: activationResponse.data.result.PhoneNumber,
              Email: response.data.Email,
            },
          });
        } else {
          setAlertMessage({ type: "success", message: "Successful" });
          this.props.history.push("/login");
        }
      } catch (e) {
        setAlertMessage({
          type: "error",
          message: e.message,
          onTryAgain: isNetworkRequestFailedError(e) ? this.register : null,
        });
      }
      this.setState({ isLoading: false });
    }
  };

  render() {
    const {
      firstName,
      middleName,
      surname,
      confirmEmail,
      email,
      phone,
      confirmPhone,
      office,
      username,
      password,
      confirmPassword,
      firstNameError,
      surnameError,
      emailError,
      confirmEmailError,
      cEmailError,
      phoneError,
      confirmPhoneError,
      cPhoneError,
      usernameError,
      passwordError,
      confirmPasswordError,
      errorMessage,
      passwordErrorMessage,
      cPasswordError,
      isLoading,
    } = this.state;

    return (
      <>
        <div className="register-main-container py-3">
          <Container>
            {isLoading && <CustomLoader text="Please Wait" />}
            <div className="register-container">
              <img
                alt="app-icon"
                src={require("../../assets/icons/app-icon.png")}
              />
              <p className="register-container-app-name">
                Premium Pension Limited
              </p>
              <div className="my-1 register-input-container">
                <Form onSubmit={this.register}>
                  <Row>
                    <Col sm={6} className="my-1 pr-sm-3 pr-md-4">
                      <GradientTextInput
                        placeholder="First Name*"
                        onChange={(e) =>
                          this.setState({
                            firstName: e.target.value,
                            firstNameError: false,
                          })
                        }
                        value={firstName}
                        errorMessage={
                          firstNameError && "First Name is required"
                        }
                        containerClasses={firstNameError && "input-error"}
                      />
                    </Col>
                    <Col sm={6} className="my-1 pl-sm-3 pl-md-4">
                      <GradientTextInput
                        placeholder="Middle Name"
                        onChange={(e) =>
                          this.setState({ middleName: e.target.value })
                        }
                        value={middleName}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6} className="my-1 pr-sm-3 pr-md-4">
                      <GradientTextInput
                        placeholder="Surname*"
                        onChange={(e) =>
                          this.setState({
                            surname: e.target.value,
                            surnameError: false,
                          })
                        }
                        value={surname}
                        errorMessage={surnameError && "Surname is required"}
                        containerClasses={surnameError && "input-error"}
                      />
                    </Col>
                    <Col sm={6} className="my-1 pl-sm-3 pl-md-4">
                      <GradientTextInput
                        placeholder="Office number"
                        onChange={(e) =>
                          this.setState({ office: e.target.value })
                        }
                        value={office}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6} className="my-1 pr-sm-3 pr-md-4">
                      <GradientTextInput
                        placeholder="Email Address*"
                        onChange={(e) =>
                          this.setState({
                            email: e.target.value,
                            emailError: false,
                          })
                        }
                        value={email}
                        errorMessage={emailError && "Email Address is required"}
                        containerClasses={emailError && "input-error"}
                        type="email"
                      />
                    </Col>
                    <Col sm={6} className="my-1 pl-sm-3 pl-md-4">
                      <GradientTextInput
                        placeholder="Confirm Email Address*"
                        onChange={(e) =>
                          this.setState({
                            confirmEmail: e.target.value,
                            confirmEmailError: false,
                          })
                        }
                        value={confirmEmail}
                        errorMessage={confirmEmailError && cEmailError}
                        containerClasses={confirmEmailError && "input-error"}
                        type="email"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6} className="my-1 pr-sm-3 pr-md-4">
                      <GradientTextInput
                        placeholder="Phone number*"
                        onChange={(e) =>
                          this.setState({
                            phone: e.target.value,
                            phoneError: false,
                          })
                        }
                        value={phone}
                        errorMessage={phoneError && "Phone Number is required"}
                        containerClasses={phoneError && errorMessage}
                      />
                    </Col>
                    <Col sm={6} className="my-1 pl-sm-3 pl-md-4">
                      <GradientTextInput
                        placeholder="Confirm Phone Number*"
                        onChange={(e) =>
                          this.setState({
                            confirmPhone: e.target.value,
                            confirmPhoneError: false,
                          })
                        }
                        value={confirmPhone}
                        errorMessage={confirmPhoneError && cPhoneError}
                        containerClasses={confirmPhoneError && "input-error"}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className="my-1">
                      <GradientTextInput
                        placeholder="Username*"
                        onChange={(e) =>
                          this.setState({
                            username: e.target.value,
                            usernameError: false,
                          })
                        }
                        value={username}
                        errorMessage={usernameError && "Username is required"}
                        containerClasses={usernameError && "input-error"}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6} className="my-1 pr-sm-3 pr-md-4">
                      <GradientTextInput
                        placeholder="Password*"
                        onChange={(e) =>
                          this.setState({
                            password: e.target.value,
                            passwordError: false,
                          })
                        }
                        value={password}
                        errorMessage={passwordError && passwordErrorMessage}
                        containerClasses={passwordError && "input-error"}
                        type="password"
                      />
                    </Col>
                    <Col sm={6} className="my-1 pl-sm-3 pl-md-4">
                      <GradientTextInput
                        placeholder="Confirm Password*"
                        onChange={(e) =>
                          this.setState({
                            confirmPassword: e.target.value,
                            confirmPasswordError: false,
                          })
                        }
                        value={confirmPassword}
                        errorMessage={confirmPasswordError && cPasswordError}
                        containerClasses={confirmPasswordError && "input-error"}
                        type="password"
                      />
                    </Col>
                  </Row>
                  <p className="register-user-type-title px-3 mt-2 mb-1">
                    User Type:
                  </p>
                  <div className="register-type-select-container px-2 my-1">
                    <SelectButton
                      containerClasses={this.buttonContainerStyle("Agent")}
                      textClasses="register-type-select-button-container-text"
                      text="Agent"
                      onClick={() => {
                        this.memberType("Agent", "Agent Code");
                      }}
                      // containerStyles={type=== 'member' && {background: 'blue'}}
                    />
                    <SelectButton
                      containerClasses={this.buttonContainerStyle("Employer")}
                      textClasses="register-type-select-button-container-text"
                      text="Employer"
                      onClick={() => {
                        this.memberType("Employer", "Employer Code");
                      }}
                    />
                    <SelectButton
                      containerClasses={this.buttonContainerStyle("Staff")}
                      textClasses="register-type-select-button-container-text"
                      text="Staff"
                      onClick={() => {
                        this.memberType("Staff", "Staff Code");
                      }}
                    />
                    <SelectButton
                      containerClasses={this.buttonContainerStyle("Member")}
                      textClasses="register-type-select-button-container-text"
                      text="Member"
                      onClick={() => {
                        this.memberType("Member", "RSA PIN");
                      }}
                    />
                    <SelectButton
                      containerClasses={this.buttonContainerStyle("nonMember")}
                      textClasses="register-type-select-button-container-text"
                      text="Non-Member"
                      onClick={() => {
                        this.memberType("nonMember");
                      }}
                    />
                  </div>
                  {this.codeField()}
                  {/* <Row>
                  <Col xs={12} className="my-1">
                    <GradientTextInput
                      placeholder="Enter RSA PIN*"
                      onChange={e => this.setState({ rsaPin: e.target.value })}
                      value={rsaPin}
                    />
                  </Col>
                </Row> */}
                  <GradientButton
                    containerClasses="mt-3 mx-auto"
                    label="Register"
                    type="submit"
                  />
                  <Link to="/login">
                    <p className="text-center">Already have account? Login</p>
                  </Link>
                </Form>
              </div>
            </div>
          </Container>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDispatchToProps = {
  setUser: authAction.setUser,
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
  setActivationModal: activationOptionModalAction.setActivationModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
